export const BILLING_INDEX = 'BILLING_INDEX'
export const BILLING_GET = 'BILLING_GET'
export const BILLING_SHOW = 'BILLING_SHOW'



// WEBPACK FOOTER //
// ./src/store/actions/billing.js